import { environment } from 'src/environments/environment';

/**
 * UI feature flag for operational Roles & Permissions enforcement (SPEC-RPE-001).
 * When `enabled` is false: no loadEffectivePermissions call; all modules/routes/actions behave as pre-enforcement.
 */
export const rolesPermissionsEnforcementConfig = {
  enabled: environment.rolesPermissionsEnforcement?.enabled === true,
} as const;

export function isRolesPermissionsEnforcementEnabled(): boolean {
  return rolesPermissionsEnforcementConfig.enabled;
}
